import { gql } from '@apollo/client'

export const totalVolumeQuery = gql`
  query totalVolume {
    volumeStat(id: "total") {
      margin
      swap
      liquidation
      mint
      burn
    }
  }
`

export const totalFeesQuery = gql`
  query totalFees {
    feeStat(id: "total") {
      margin
      swap
      liquidation
      mint
      burn
    }
  }
`

export const totalSupplyQuery = gql`
  query glpSupply {
    glpStat(id: "total") {
      glpSupply
    }
  }
`

export const totalInterest = gql`
  query totalInterest {
    tradingStat(id: "total") {
      longOpenInterest
      shortOpenInterest
    }
  }
`

export const totalUsers = gql`
  query totalUsers {
    userStat(id: "total") {
      uniqueCount
    }
  }
`
